module.exports = __webpack_public_path__ + "img/network2.9183d0ab.png";